import React from 'react'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'

//this component is different than <ReadMore> in sense that this one  hides/shows entire children on clicking of  "show more/show less"
function ShowMoreCompoents({
  children,
  className,
  isShowMore,
  showText = '',
  hideText = '',
  setIsShowMore,
  showMoreButtonCSS = ''
}) {
  const { t } = useTranslation()
  const toggleShowMore = () => {
    setIsShowMore(!isShowMore)
  }

  return (
    <div className={`${styles.showMoreCompContainer} ${className}`}>
      {isShowMore && <div>{children}</div>}

      <button
        aria-label={isShowMore ? t('global.seeMore') : t('global.seeLess')}
        onClick={toggleShowMore}
        className={`${styles.showOrHide} ${showMoreButtonCSS}`}>
        {isShowMore ? (
          <React.Fragment>
            <span className={styles.buttonText}> {hideText}</span>
            <Icon styleModifier={styles.showMoreIcon} size='large24' name='chevron-up24' />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <span className={styles.buttonText}> {showText}</span>
            <Icon styleModifier={styles.showMoreIcon} size='large24' name='chevron-down24' />
          </React.Fragment>
        )}
      </button>
    </div>
  )
}

export default ShowMoreCompoents
